import { Link as RouterLink, useLocation } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import { Button, Typography, Container, Box } from '@mui/material';
import Page from '../../components/Page';
import picSuccess from './thankyou.JPG';
import picFailed from './wrong.JPG'; // صورة فيها علامة X كبيرة

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: '80%',
  margin: 'auto',
  minHeight: '100vh',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  padding: theme.spacing(12, 0),
  textAlign: 'center',
  alignItems: 'center',
  backgroundColor: 'white',
}));

export default function ThankYou() {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const status = queryParams.get('status'); // success أو failed

  const isSuccess = status === 'success';

  return (
    <Page title="thank you">
      <ContentStyle>
        <Box sx={{ maxWidth: '750px' }}>
          <img src={isSuccess ? picSuccess : picFailed} alt='' />
        </Box>

        {isSuccess ? (
          <>
            <Typography sx={{ color: 'black', fontSize: '1.2rem', fontWeight: '600', mt: 2 }}>
              We have received your payment and you must receive your coins <br /> ----------------------
            </Typography>
            <Button to="/dashboard/wallet" size="large" variant="contained" component={RouterLink} sx={{ mt: 3 }}>
              Check my wallet
            </Button>
          </>
        ) : (
          <>
            <Typography sx={{ color: 'red', fontSize: '1.2rem', fontWeight: '600', mt: 2 }}>
              ❌ Payment Failed <br /> ----------------------
            </Typography>
            <Button to="/" size="large" variant="contained" color="error" component={RouterLink} sx={{ mt: 3 }}>
              Try Again
            </Button>
          </>
        )}
      </ContentStyle>
    </Page>
  );
}
